import { useChannelContext } from '../Channel/Context'
import { useContext } from './Context'
import { AllChatAttachments } from './AllChatAttachments'
import { ChatMessages } from './ChatMessages'
import { StagedAttachments } from './StagedAttachments'

// The shared rendering every mount keeps by default — composer inline, one aggregate
// attachments row under it, then the thread. A mount needing different structure overrides
// `components.layout` instead of forking this provider tree (chatComponents.tsx → `layout`;
// the inbox thread's override is Inbox/InboxThreadLayout.tsx).
export const DefaultLayout = () => {
  const { components, ...props } = useContext()
  const { attachments, removeAttachment, status } = useChannelContext()

  return (
    <>
      <div className="mb-1">
        <components.errorDisplay {...props} />
      </div>

      <components.input />
      <StagedAttachments attachments={attachments} onRemove={removeAttachment} disabled={status?.busy} />
      <components.chatActionContainer {...props} />
      <AllChatAttachments />

      <hr />

      <ChatMessages />
    </>
  )
}
